module.exports = __webpack_public_path__ + "static/media/40.45d841b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/40.jpg
// module id = 730
// module chunks = 0